<script lang="ts">
    import {Component, toNative, Vue} from 'vue-facing-decorator'
    import HotelMap from '@/components/search/offers/HotelMap.vue'

    @Component({mixins: [HotelMap]})
    export class InsuranceMap extends Vue {
        //TODO InsuranceMap
        async load() {
            await this.initMap()
        }

        setMapPosition() {
            this.map.fitBounds(this.bounds)
            this.mapPositionInit = true
        }

        saveMapPosition() {}
    }

    export default {...toNative(InsuranceMap), ssrRender: HotelMap.ssrRender}
</script>

<style scoped lang="scss">
    @use 'vuetify/settings';
    @use 'sass:map';

    .map {
        position: fixed;

        @media #{map.get(settings.$display-breakpoints, 'xs')} {
            margin-left: -(settings.$container-padding-x);
        }

        > div {
            height: 100%;
        }
    }

    :deep(.custom-label) {
        background-color: rgb(var(--v-theme-primary)) !important;
        border: 3px solid white !important;
        border-radius: 20px;
        padding: 4px !important;
        color: white !important;
        position: absolute;
        top: 100px;
        left: 50%;
        transform: translateX(-25%);
    }
</style>
